import React, { useState } from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import { useAuth } from '../context/AuthContext';
import { Button } from 'react-bootstrap';
import { FaGoogle } from 'react-icons/fa';
import { useAlert } from '../AlertContext';
import { useNavigate } from 'react-router-dom';

const GoogleLoginButton = ({ isLogin = true }) => {
  const { googleLogin } = useAuth();
  const { showAlert } = useAlert();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const login = useGoogleLogin({
    flow: "implicit",
    onSuccess: async (tokenResponse) => {
      setIsLoading(true);
      try {
        console.log('Google auth response:', tokenResponse);
        const result = await googleLogin(tokenResponse);
        console.log('Backend response:', result);
        showAlert(`Google ${isLogin ? 'Login' : 'Signup'} successful!`, "success");
        
        // Check if profile completion is needed
        if (result.needsProfileCompletion) {
          navigate('/complete-profile', { 
            state: { 
              fromGoogleSignup: true,
              userData: result.user 
            }
          });
        } else {
          navigate('/dashboard');
        }
      } catch (error) {
        console.error('Google auth error details:', error);
        showAlert(error.message || 'Google authentication failed', "danger");
      } finally {
        setIsLoading(false);
      }
    },
    onError: (error) => {
      console.error('Google OAuth error:', error);
      showAlert('Google login failed. Please try again.', "danger");
    },
  });

  return (
    <Button 
      variant="outline-danger"
      className="google-btn"
      onClick={() => login()}
      disabled={isLoading}
    >
      <FaGoogle className="social-icon" /> 
      {isLoading ? 'Processing...' : ` Google`}
    </Button>
  );
};

export default GoogleLoginButton;